<template>
    <left-sidebar-layout
        class="product-listings-section"
        :hide-sidebar="hideSidebar"
    >
        <secondary-nav-menu
            :items="categories"
            class="mobile-secondary-nav d-lg-none"
            slot="mobile-sidebar"
        />

        <secondary-nav-menu
            :items="categories"
            class="desktop-secondary-nav"
            slot="desktop-sidebar"
        />

        <product-listings-content
            :breadcrumbs="listingsContent.breadcrumbs"
            :filter-title="listingsContent.filterTitle"
            :filters="listingsContent.filters"
            :sort-title="listingsContent.sortTitle"
            :sorts="listingsContent.sorts"
            :items="listingsContent.items"
            :nav-items="listingsContent.navItems"
            :read-more-button-text="listingsContent.readMoreButtonText"
            :read-more-content="listingsContent.readMoreContent"
            :selected-filters.sync="selectedFiltersProxy"
            :selected-sorts.sync="selectedSortsProxy"
            :category-prefix="listingsContent.categoryPrefix"
            :hide-breadcrumbs="hideBreadcrumbs"
            :heading-text="headingText"
            :hide-nav-items="hideNavItems"
            :columns="hideSidebar ? 4 : 3"
            slot="primary-content"
        />
    </left-sidebar-layout>
</template>

<script>
    import LeftSidebarLayout from '../LeftSidebarLayout/LeftSidebarLayout';
    import SecondaryNavMenu from '../../molecules/SecondaryNavMenu/SecondaryNavMenu';
    import ProductListingsContent from '../ProductListingsContent/ProductListingsContent';
    import createPropProxy from '../../../lib/prop-proxies';

    export default {
        name: 'product-listings-section',

        components: { LeftSidebarLayout, ProductListingsContent, SecondaryNavMenu },

        props: {
            categories: {
                type: Array,
                default: () => ([]),
            },

            listingsContent: {
                type: Object,
                default: () => ({}),
            },

            selectedFilters: {
                type: Array,
                default: () => ([]),
            },

            selectedSorts: {
                type: Array,
                default: () => ([]),
            },

            hideBreadcrumbs: {
                type: Boolean,
                default: false,
            },

            headingText: {
                type: String,
                default: '',
            },

            hideNavItems: {
                type: Boolean,
                default: false,
            },

            hideSidebar: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            /**
             * Create selectedFiltersProxy and selectedSortsProxy.
             *
             * @returns {object}
             */
            ...createPropProxy(['selectedFilters', 'selectedSorts']),
        },
    };
</script>

<style lang="scss" scoped>
    .secondary-nav-menu {
        margin-bottom: 10px;
        max-width: fit-content;
        margin-left: auto;
        margin-right: auto;
        @include media-breakpoint-up(lg) {
            max-width: unset;
        }
    }
</style>
